import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { IAppStore } from '../../../types/IAppStore';

export const selectorGetWorkTimes = createSelector(
  (state: IAppStore) => {
    if (state.reservesSystemSettings.isActiveRestaurantSchedule) {
      return state.schedule.restaurantWorkTimes;
    }
    return state.schedule.bookingWorkTimes;
  },
  (workTime) => workTime,
);

export const selectorGetGetActiveRestaurantSchedule = createSelector(
  (state: IAppStore) => state.prepaySettings?.isActiveRestaurantSchedule,
  (activeRestaurantSchedule) => activeRestaurantSchedule,
);

export const usePrepayAcceptanceSchedule = () => {
  const workTimes = useSelector(selectorGetWorkTimes);
  const isActiveRestaurantSchedule = useSelector(selectorGetGetActiveRestaurantSchedule);

  return {
    workTimes,
    isActiveRestaurantSchedule,
  };
};
